import type { AttemptsToEnablePrinting } from '../domain';

const LOCAL_STORAGE_KEY = {
  command: 'is_activated_comanda',
  checklist: 'is_activated_printer_checklist',
  autoPrint: 'autoPrintEnabled',
  attempts: 'attempts_to_print_order',
} as const;

function updateIsActivatedCommand(value: boolean) {
  window.localStorage.setItem(LOCAL_STORAGE_KEY.command, value ? '1' : '0');
}

function readIsActivatedCommand(): boolean {
  return window.localStorage.getItem(LOCAL_STORAGE_KEY.command) === '1';
}

function updateIsActivatedChecklist(value: boolean) {
  window.localStorage.setItem(LOCAL_STORAGE_KEY.checklist, value ? '1' : '0');
}

function readIsActivatedChecklist(): boolean {
  return window.localStorage.getItem(LOCAL_STORAGE_KEY.checklist) === '1';
}

function updateIsActivatedAutoPrint(value: boolean) {
  window.localStorage.setItem(LOCAL_STORAGE_KEY.autoPrint, value.toString());
}

function readIsActivatedAutoPrint(): boolean {
  return window.localStorage.getItem(LOCAL_STORAGE_KEY.autoPrint) === 'true';
}

function deleteAttemptsToEnablePrinting() {
  window.localStorage.removeItem(LOCAL_STORAGE_KEY.attempts);
}

function updateAttemptsToEnablePrinting(params: AttemptsToEnablePrinting) {
  window.localStorage.setItem(
    LOCAL_STORAGE_KEY.attempts,
    JSON.stringify(params),
  );
}

function readAttemptsToEnablePrinting(): AttemptsToEnablePrinting {
  const lsValue = localStorage.getItem(LOCAL_STORAGE_KEY.attempts);
  return lsValue ? JSON.parse(lsValue) : { amount: 0, firstDate: NaN };
}

export const orderPrintingConfigRepository = {
  updateIsActivatedCommand,
  readIsActivatedCommand,
  updateIsActivatedChecklist,
  readIsActivatedChecklist,
  updateIsActivatedAutoPrint,
  readIsActivatedAutoPrint,
  deleteAttemptsToEnablePrinting,
  updateAttemptsToEnablePrinting,
  readAttemptsToEnablePrinting,
};
